export default __webpack_public_path__ + "static/media/GreenQRCodeIcon.b3c6aff6.svg";